import { Table } from "antd";
import { AiOutlinePlus } from "react-icons/ai";
import { FiUsers } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { IoTrashBinOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import Moment from "react-moment";

export default function AllModules() {
  const modules = [
    { id: 4, name: "Customers" },
    { id: 1, name: "Users" },
    { id: 2, name: "Models" },
    { id: 3, name: "Vehicles" },
    { id: 5, name: "Sites" },
    { id: 6, name: "Stations" },
  ];

  const columns = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Name",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700">
          <Moment format="Do, MMM YYYY hh:mm A">{record.timein}</Moment>
        </span>
      ),
    },
    {
      title: "Address",
      width: 380,
      render: (record: any) => (
        <span className="text-gray-700">
          <Moment format="Do, MMM YYYY hh:mm A">{record.timein}</Moment>
        </span>
      ),
    },
    {
      title: "Edit",
      width: 40,
      render: (record: any) => (
        <button className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-yellow-100 hover:bg-red-100 cursor-pointer">
          <FiEdit />
          <span className="ml-1">Edit</span>
        </button>
      ),
    },
    {
      title: "Delete",
      width: 40,
      render: (record: any) => (
        <button className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-100 cursor-pointer">
          <IoTrashBinOutline />
          <span className="ml-1">Delete</span>
        </button>
      ),
    },
  ];

  return (
    <div className="grid grid-cols-12 gap-0 m-4 border rounded-lg">
      <div className="bg-white col-span-2 rounded-l-lg border-r h-full">
        <div className="border-b p-4 flex justify-between items-center h-18">
          <div className="">
            <span className="text-lg font-bold">Customers : </span>
            <span>All</span>
            <div className="">-</div>
          </div>
        </div>
        {modules.map((module: any) => (
          <NavLink to={""} className="border-b p-4 flex items-center">
            <div className="">
              <FiUsers />
            </div>
            <div className="ml-2">{module.name}</div>
          </NavLink>
        ))}
      </div>
      <div className="bg-white col-span-10 h-full rounded-r-lg">
        <div className="border-b p-4 flex justify-between items-center h-18">
          <div className="">
            <span className="text-lg font-bold">Customers : </span>
            <span>All</span>
            <div className="">Manage all customers</div>
          </div>
          <div className="border rounded-md p-2 flex items-center">
            <AiOutlinePlus />
            <span className="ml-2">New</span>
          </div>
        </div>
        <div className="">
          <Table size="small" dataSource={modules} columns={columns} />
        </div>
      </div>
    </div>
  );
}
